<pbc-sorter [config]="GutachtenSorterConfig" [sorter]="gutachtens.sorter$ | async" (sorterChange)="gutachtens.sorter$.next($event)"></pbc-sorter>
